// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"207":"updates","594":"about","964":"product"}[chunkId] + "." + {"207":"0fbc8189","594":"68cde69d","964":"bdf2edc6"}[chunkId] + ".js";
};